import { getTranslation } from 'helpers/getTranslation';

export const getCoursesTableColumnsRootAdmin = () => [
  {
    key: 'title',
    label: getTranslation('courses_page.table_keys.title'),
    minWidth: 400,
    sortable: true,
  },
  {
    key: 'status',
    label: getTranslation('courses_page.table_keys.status'),
    sortable: true,
  },
  {
    key: 'authors',
    label: getTranslation('courses_page.table_keys.authors'),
    sortable: false,
  },
  {
    key: 'school',
    label: getTranslation('courses_page.table_keys.school'),
    sortable: false,
  },
  {
    key: 'createdAt',
    label: getTranslation('courses_page.table_keys.createdAt'),
    sortable: true,
  },
  {
    key: 'lastActionAt',
    label: getTranslation('courses_page.table_keys.updatedAt'),
    sortable: true,
  },
];
export const getCoursesTableColumns = () => [
  {
    key: 'title',
    label: getTranslation('courses_page.table_keys.title'),
    minWidth: 400,
    sortable: true,
  },
  {
    key: 'status',
    label: getTranslation('courses_page.table_keys.status'),
    sortable: true,
  },
  {
    key: 'authors',
    label: getTranslation('courses_page.table_keys.authors'),
    sortable: false,
  },
  {
    key: 'createdAt',
    label: getTranslation('courses_page.table_keys.createdAt'),
    sortable: true,
  },
  {
    key: 'lastActionAt',
    label: getTranslation('courses_page.table_keys.updatedAt'),
    sortable: true,
  },
];
